// src/departamentos/CrearDepartamento.jsx
import React, { useState } from "react";
import { Global } from "../helpers/Global";
import { useToast } from "../hooks/useToast";

// ===== MUI =====
import { Box, Paper, Typography, Stack, TextField, Button } from "@mui/material";

export const CrearDepartamento = () => {
  const toast = useToast();

  // =========================
  // Form
  // =========================
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");

  // =========================
  // Loading
  // =========================
  const [saving, setSaving] = useState(false);

  // =========================
  // Helpers
  // =========================
  const authHeadersJson = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  const resetForm = () => {
    setNombre("");
    setDescripcion("");
  };

  // =========================
  // Submit
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    const nombreTrim = nombre.trim();
    const descripcionTrim = descripcion.trim();

    if (!nombreTrim) {
      toast.error?.("Debes indicar el nombre del departamento");
      return;
    }

    try {
      setSaving(true);

      const res = await fetch(`${Global.url}departamentos`, {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify({
          nombre: nombreTrim,
          descripcion: descripcionTrim,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        toast.error?.(data?.message || "Error al crear el departamento");
        return;
      }

      resetForm();
      toast.success?.("Departamento creado correctamente");
    } catch (error) {
      console.error("Error al crear departamento:", error);
      toast.error?.("Error inesperado al crear el departamento");
    } finally {
      setSaving(false);
    }
  };

  /// =========================
  // Render
  // =========================
  return (
    <Box className="appContainer">
      <Stack spacing={2}>
        {/* Cabecera */}
        <Box className="pageHeader">
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Crear nuevo departamento
          </Typography>
        </Box>

        {/* ✅ Formulario single-column */}
        <Box className="contentContainer contentContainer--formSingle">
          <Paper className="formPaper">
            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <TextField
                  label="Nombre del departamento"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                  autoFocus
                  disabled={saving}
                />

                <TextField
                  label="Descripción (opcional)"
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  multiline
                  minRows={3}
                  disabled={saving}
                />

                <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                  <Button type="submit" disabled={saving} sx={{ height: 40, minWidth: 180 }}>
                    {saving ? "Guardando..." : "Guardar departamento"}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Paper>
        </Box>
      </Stack>
    </Box>
  );


};

export default CrearDepartamento;
